import vue from 'vue'
// 全局通知事件
export default new vue({});
